import PropTypes from 'prop-types';

var Variants;
(function (Variants) {
    Variants["SUCCESS"] = "success";
    /**
     * @deprecated
     */
    Variants["WARNING"] = "warning";
    Variants["DANGER"] = "danger";
    /**
     * @deprecated
     */
    Variants["INFORMATIVE"] = "informative";
})(Variants || (Variants = {}));
var propTypes = {
    title: PropTypes.string,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    buttonText: PropTypes.string.isRequired,
    variant: PropTypes.oneOf([
        Variants.SUCCESS,
        Variants.WARNING,
        Variants.DANGER,
        Variants.INFORMATIVE,
    ]),
    position: PropTypes.string,
    limit: PropTypes.number,
    onClose: PropTypes.func,
    onClick: PropTypes.func,
    autoClose: PropTypes.number,
    className: PropTypes.string,
    'data-testid': PropTypes.string,
    /** @deprecated */
    urgent: PropTypes.bool,
    containerId: PropTypes.string,
};
var defaultProps = {
    title: '',
    variant: Variants.SUCCESS,
    position: 'bottom-left',
    autoClose: 6000,
    urgent: true,
    buttonText: 'Dismiss',
    'data-testid': 'toast',
    containerId: 'root-toast-container',
};

export { Variants, defaultProps, propTypes };
